import { store } from '@betacrew/jars-flux'
export const componentKey = "FILE_SHARE";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setUploadedFile: (state, action) => {
            state.uploadedFile = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
    }, 
    initialReducerState: {
        uploadedFile: null,
        loadingState: false,
        
    }
});
export const { setUploadedFile, setLoadingState } = actions;